<template>
    <div id="monthly-payments-component">

        <div id="mainContent">
            <b-table sticky-header="80vh" responsive id="my-table" striped hover :fields="fields" :busy="isBusy"
                     :filter="filter" :items="pagination.data">
                <template #cell(fecha)="{item}">
                    <input v-model="item.editedFecha" type="text" class="form-control" :placeholder="item.fecha" />
                </template>
                <template #cell(costo)="{item}">
                    <input v-model="item.editedCosto" type="text" class="form-control" :placeholder="'$'+item.costo" />
                </template>
                <template #cell(accion)="{item}">
                    <div class="dropdown">
                        <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-cogs"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" href="javascript:void(0)" v-on:click="onClickDelete(item.id)">Borrar</a>
                            <a class="dropdown-item" href="javascript:void(0)" v-if="role_id===1"
                               v-on:click="updateReg(item)">Modificar</a>
                        </div>
                    </div>
                </template>
            </b-table>


        </div>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {paymentsService} from "../../Services/Payments.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: "monthly-payments-component",
    mixins: [myMixins],
    props: {
        client_id: {
            type: Number,
            required: true
        },
        role_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            filter: null,
            modalShow: false,
            isBusy: false,
            modificar: false,
            path_storage: '',
            facturas: [],
            fields: [
                {key: 'fecha'},
                {key: 'costo'},
                {key: 'accion'}
            ],
            params: {
                limit: 10,
                page: 1,
                where: [
                    {
                        field: 'client_id',
                        operator: '=',
                        value: this.client_id,
                    }
                ],
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            tituloBtn: 'Subir',
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await paymentsService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async updateReg(item) {
            let resp = '';
            resp = await paymentsService.updateOne(item.id, item);
            this.modificar = false;
            this.showModal = false;
            this.getAlert(resp.process);
            await this.index();

        },
        async index() {

            this.showModal = false;
            this.isBusy = true;

            this.pagination = await paymentsService.getMany(this.params);
            this.isBusy = false;
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        getBills() {
            //console.log('getNameFile');
            this.getNameFile(event, 'factura_name');
        },
    },
    mounted() {
        //console.log('invoice-quotings-component/quoting_id', this.quoting_id);
        //paymentsService.setRoute(this.route)
        this.index();
    }
}
</script>

